export class ContentContactUs {
  id: any;
  contactUsLabel: any;
  contactUsUrl: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['contactUsLabel']) {
        this.contactUsLabel = contentjson['contactUsLabel'];
      }
      if (contentjson['contactUsUrl']) {
        this.contactUsUrl = contentjson['contactUsUrl'];
      }
    }
  }
}
